<template>
  <v-menu
    v-model="isVisibleState"
    :position-x="coords[0]"
    :position-y="coords[1]"
    max-width="100%"
    absolute
    :close-on-content-click="false"
    v-bind="menuAttrs"
  >
    <v-card :width="width">
      <slot></slot>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'AppDetachMenu',

  props: {
    isVisible: {
      required: true,
      type: Boolean,
      default: false,
    },

    menuAttrs: {
      required: false,
      type: Object,
      default: () => ({}),
    },

    coords: {
      required: false,
      type: Array,
      default: () => [0, 0],
    },

    width: {
      required: false,
      type: Number,
      default: 0,
    },
  },

  computed: {
    isVisibleState: {
      get() {
        return this.isVisible;
      },
      set(value) {
        this.toggleVisible(value);
      },
    },
  },

  watch: {
    isVisible(value) {
      if (value) {
        this.reset();
      }
    },
  },

  methods: {
    toggleVisible(state) {
      this.$emit('toggle-visible', state);
    },

    reset() {
      this.$emit('reset');
    },
  },
};
</script>

<style scoped lang="scss">
.v-menu__content {
  &::v-deep .v-card {
    & > .v-card__subtitle,
    & > .v-card__text,
    & > .v-card__actions {
      padding-left: 1rem;
      padding-right: 1rem;
    }
    & > .v-card__actions {
      padding-bottom: 1rem;
    }
  }
}
</style>
